import { useContext, useMemo } from 'react';
import cls from 'classnames';
import { faSave, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FormContext, StyledButton } from '../FormElements';
import './index.scss';

export const SaveButton = ({
    savingLabel = 'Saving', saving = false, label = 'Save', icon = faSave, className = '',
    disabled = false, form = null,
    ...props
}) => {
    const context = useContext(FormContext);
    let fieldSaving = saving;
    let formId = form;

    if (context) {
        fieldSaving = context.saving || saving;
        formId = context.formId;
    }

    const buttonLabel = useMemo(() => {
        if (fieldSaving) {
            return savingLabel;
        }

        return label;
    }, [fieldSaving, label, savingLabel]);

    return (
        <StyledButton
            disabled={Boolean(fieldSaving || disabled)}
            type="submit"
            color="primary"
            className={cls('save-button', className)}
            form={formId}
            startIcon={fieldSaving ? faSpinner : Boolean(icon) && icon}
            StartIconProps={{
                spin: !!fieldSaving,
            }}
            {...props}
        >
            {buttonLabel}
        </StyledButton>
    );
};